import { useState } from "react";
import PageTitle from "components/layout/PageTitle";
import { Paper, Stack, Collapse } from "@mui/material";
import LinqFilters from "./LinqFilters";
import { LinqTable } from "./LinqTable";

export const LinqRequests = () => {
    const [filterVisibility, setFilterVisibility] = useState(true);

    return (
        <Stack direction="column">
            <PageTitle title="Search for Linq Requests" />

            <Stack
                px={2}
                pb={2}
                gap={2}
                direction="row"
                alignItems="flex-start"
            >
                <Collapse
                    orientation="horizontal"
                    in={filterVisibility}
                    sx={{
                        display: filterVisibility ? "block" : "none",
                        minWidth: "300px",
                        maxWidth: "400px",
                    }}
                >
                    <Paper
                        sx={{
                            borderRadius: "10px",
                            height: "fit-content",
                        }}
                    >
                        <LinqFilters />
                    </Paper>
                </Collapse>

                <Paper
                    sx={{
                        flexGrow: 1,
                        p: 2,
                        borderRadius: "10px",
                        height: "fit-content",
                        minWidth: 0,
                    }}
                >
                    <LinqTable setFilterVisibility={setFilterVisibility} />
                </Paper>
            </Stack>
        </Stack>
    );
};

export default LinqRequests;
